import { render, staticRenderFns } from "./trainItemConfig.vue?vue&type=template&id=5686a0bc&scoped=true"
import script from "./trainItemConfig.vue?vue&type=script&lang=js"
export * from "./trainItemConfig.vue?vue&type=script&lang=js"
import style0 from "./trainItemConfig.vue?vue&type=style&index=0&id=5686a0bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686a0bc",
  null
  
)

export default component.exports